import { useCallback } from 'react';

import { type AirActionTrackingLocation, useTrackClickedFileUpload } from '@air/analytics';

import { useUploadContext } from '~/components/PrivateDropzone/UploadContext';
import { useActiveSubscriptionCallback } from '~/swr-hooks/subscriptions/useActiveSubscriptionCallback';

export type UseUploadFilesFromComputerParams = {
  trackLocation: AirActionTrackingLocation;
  pickDestination?: boolean;
};

export const useUploadFilesFromComputer = ({ trackLocation, pickDestination }: UseUploadFilesFromComputerParams) => {
  const { openUploader } = useUploadContext();
  const { activeSubscriptionCallback } = useActiveSubscriptionCallback();
  const { trackClickedFileUpload } = useTrackClickedFileUpload();

  const uploadFilesFromComputer = useCallback(
    () =>
      activeSubscriptionCallback(() => {
        openUploader(pickDestination ? { pickDestination: true } : undefined);
        trackClickedFileUpload({ location: trackLocation });
      }),
    [activeSubscriptionCallback, openUploader, pickDestination, trackLocation, trackClickedFileUpload],
  );

  return {
    uploadFilesFromComputer,
  };
};
